import { render, staticRenderFns } from "./LogHistory.vue?vue&type=template&id=ddc06c20&scoped=true&"
import script from "./LogHistory.vue?vue&type=script&lang=js&"
export * from "./LogHistory.vue?vue&type=script&lang=js&"
import style0 from "./LogHistory.vue?vue&type=style&index=0&id=ddc06c20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc06c20",
  null
  
)

export default component.exports